import React, { useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../Dashboard';
import useCustomHook from './hooks';
import { getDynamicObjectAction } from 'utility';
export default function HomeParent() {
  const navigate = useNavigate();
  const { loading, setLoading } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'contentDashboardPage',
      'contentGuildDashboardPage'
    ])
   useEffect(() => {
   
    let val = localStorage.getItem('TOKEN') || '';
    val = ['undefined', 'null', 'NaN'].indexOf(val) > -1 ? '' : val;
    const destination = localStorage.getItem('destination');
    const fileHashCode = localStorage.getItem('fileHashCode');
    if (destination || fileHashCode) {
      destination && navigate(destination);
      destination && localStorage.removeItem('destination');
      if (fileHashCode) {
        const t = localStorage.getItem('fileHashTimeExpire');
        const date1 = new Date(t);
        const date2 = new Date();
        const diffTime = Math.abs(date2 - date1);
        const minuts = Math.ceil(diffTime / (1000 * 60)); // munits
        if (minuts < 10) {
          fileHashCode && navigate(`/GetFile/${fileHashCode}`);
        } else {
          localStorage.removeItem('fileHashCode');
          localStorage.removeItem('fileHashTimeExpire');
        }
      }
    } else {
      setLoading(false);
    }
  }, []);
  return <>
    {(actionsList['contentDashboardPage'] || actionsList['contentGuildDashboardPage']) && (!loading && <Dashboard />)}
  </>;
}
